import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import SelectionList from "../SelectionList";
import ModalHeading from '../ModalHeading';
import ButtonContent from '../ButtonContent';
import { COLORS } from '../../styles/colors';
import { AlertJsMessage } from './../../helpers.js'

export class EditDayModal extends Component {

  constructor(props){
    super(props);
    this.state = {
      search: '',
      workoutType: 'all',
      day: 0,
      week: 0,
      formData: {
        rest: false,
        message: '',
        workoutId: 0,
        type: 'workout',
      }
    }
  }
  setFormData(){
    const { item, day, week } = this.props;
    if (item) {
      this.setState({
        search: '',
        workoutType: 'all',
        day: day,
        week: week,
        formData:{
          ...item,
          type: item.type ? item.type : 'workout'
        }
      })
    }
  }

  componentDidUpdate(prevProps){
    const { item, day, week } = this.props;
    if (item && day && week) {
      if (this.state.day !== day || this.state.week !== week) {
        this.setFormData();
      }
    }
  }
  handleTypeChange = (event, type) => {
    const { item } = this.props;
    if (type) {
      this.setState({
        ...this.state,
        formData: {
          ...item,
          rest: (type === 'rest') ? true : false,
          type: type,
          message: ""
        }
      })
    }

  }
  handleChange = field => event => {
    if (event.target) {
      this.setState({
        ...this.state,
        formData: {
          ...this.state.formData,
          [field]: event.target.value
        }
      })
    }
  }
  handleWorkoutPick(workout){
    const getWorkout = Object.values(workout);
    this.setState({
      ...this.state,
      formData: {
        ...this.state.formData,
        workoutId: getWorkout[0] ? getWorkout[0].id : 0,
        isEdited: this.props.actionType === 'edit'
      }
    })

  }
  validate(data,toNext){
    if (data.type === 'cardio' && !data.message) {
      AlertJsMessage("Message must be set if selecting Cardio Day.");
    }else if(data.type === 'workout' && !data.workoutId){
      AlertJsMessage("Workout must be selected.");
    } else {
      if (data.type === 'rest' || data.type === 'cardio') delete data.workoutId;
      this.props.save(data,toNext);
    }
  }


  render() {
    const {item, opened, close, day, week, workouts, user, cats} = this.props;
    const { formData } = this.state;
    const PlusIcon = ({active}) => (
      <FontAwesomeIcon
        icon="plus"
        style={{
          color: active ? COLORS.white : COLORS.grey,
          marginRight: 5
        }}/>
    )
    if (item && day && week) {
      return (
        <Modal
          className="modal show"
          open={opened}
          onClose={() => { close() }}
        >

          <div className="modalBody modal-content" style={{width:650, minHeight: 500}}>
            <ModalHeading
              text={`Week ${week} - Day ${day}`}
              closeModal={() => close()}/>
            <div className="modalContent" style={{paddingBottom:0}}>
              <div style={{display:'flex', justifyContent:'center'}}>
                <ToggleButtonGroup
                  value={formData.type}
                  onChange={this.handleTypeChange} exclusive>
                  <ToggleButton value="workout"
                    style={{marginRight: 10, width: 178}}>
                    <PlusIcon active={formData.type === 'workout'}  />
                    Workout
                  </ToggleButton>
                  <ToggleButton value='rest'
                    style={{marginRight: 10, width: 178}}>
                    <PlusIcon active={formData.type === 'rest'} />
                    Rest Day
                  </ToggleButton>
                  <ToggleButton value='cardio' style={{width:178}}>
                    <PlusIcon active={formData.type === 'cardio'}  />
                    Cardio Day
                  </ToggleButton>

                </ToggleButtonGroup>
              </div>

              <br />

              {
                (formData.type === 'rest') ? (
                  <TextField
                      label='Rest Instructions'
                      placeholder="Rest Day"
                      value={formData.message}
                      onChange={this.handleChange('message')}
                      margin="dense"
                      variant="outlined"
                      type="text"
                      helperText="(optional)"
                      inputProps={{maxLength: 500}}
                    />
                ) : null
              }
              {
                (formData.type === 'cardio') ? (
                  <TextField
                    label='Cardio Instructions'
                    placeholder="Cardio Day"
                    value={formData.message}
                    onChange={this.handleChange('message')}
                    margin="dense"
                    variant="outlined"
                    type="text"
                    inputProps={{maxLength: 500}}
                    />
                ) : null
              }
            </div>
            {
              (formData.type === 'workout') ? (
                <SelectionList
                  addSelectedClass={true}
                  maxListHeight={275}
                  items={Object.values(workouts)}
                  selectedItems={formData.workoutId ? {[formData.workoutId] : {...workouts[formData.workoutId]}} : {} }
                  updateSelectedItems={(selected) => this.handleWorkoutPick(selected)}
                  categories={Object.values(cats)}
                  categoryField="categoryId"
                  creatorTabs={true}
                  user={user}
                  hideTabs = {[1,2]}
                  fetchMore = {this.props.fetchMore}
                  resetListing = {this.props.resetWorkouts}
                  isLoadMore = {this.props.isLoadMore}
                  maxSelected={1}
                  isEditDay={true}
                  />
              ) : null
            }
            <div className="modalContent">
              {
                (day === 7) ? null : (
                  <Button
                    style={{marginRight: 10}}
                    onClick={(details) => this.validate(this.state.formData,true)}
                    variant="contained"  color="primary">
                    <ButtonContent
                      text="Save And Edit Next Day"
                      icon="chevron-right"
                      />
                  </Button>
                )
              }
              <Button
                onClick={(details) => {this.validate(this.state.formData,false)}}
                variant="contained">
                <ButtonContent
                  text="Save And Close"
                  icon="chevron-right"
                  />

              </Button>

            </div>

          </div>
        </Modal>
      )
    }
    return null;
  }
}
export default EditDayModal;



// WEBPACK FOOTER //
// ./src/components/programs/EditDayModal.js